import { Row, Badge, Col } from "reactstrap";
import { FormattedMessage } from "react-intl";
import ButtonSendActivationMail from "../Button/ButtonSendActivationMail";

export default function FoundUserInfo(props) {
  if (props.foundUser.UserFound !== false) {
    return (
      <Row>
        <Col xs="12">
          <div className="card card-body mt-3" style={{ width: "70%" }}>
            <div className="align-items-baseline d-flex">
              <p className="lead float-start ms-3">
                <FormattedMessage id="Id" />
              </p>
              <p className="float-start ms-2">{props.foundUser.Id}</p>
              {!props.foundUser.Activated && !props.foundUser.IsDeleted && (
                <div className="col ms-auto">
                  <ButtonSendActivationMail
                    user={{ email: props.foundUser.Email }}
                    useDialog={true}
                    printButtonText={true}
                  />
                </div>
              )}
            </div>

            <div className="align-items-baseline d-flex">
              <p className="lead float-start ms-3">
                <FormattedMessage id="Email" />:
              </p>
              <p className="float-start ms-2">{props.foundUser.Email}</p>
            </div>

            <div className="align-items-baseline d-flex">
              <p className="lead float-start ms-3">
                <FormattedMessage id="Created" />:
              </p>
              <p className="float-start ms-2">{props.foundUser.Created}</p>
            </div>

            <div className="align-items-baseline d-flex">
              <p className="lead float-start ms-3">
                <FormattedMessage id="Activated" />:
              </p>
              <p className="float-start ms-2">
                {props.foundUser.Activated ? (
                  <FormattedMessage id="true" />
                ) : (
                  <FormattedMessage id="false" />
                )}
              </p>
            </div>

            <div className="align-items-baseline d-flex">
              <p className="lead float-start ms-3">
                <FormattedMessage id="IsDeleted" />:
              </p>
              <p className="float-start ms-2">
                {props.foundUser.IsDeleted ? (
                  <FormattedMessage id="true" />
                ) : (
                  <FormattedMessage id="false" />
                )}
              </p>
            </div>

            <div className="align-items-baseline d-flex">
              <p className="lead float-start ms-3">
                <FormattedMessage id="Name" />:
              </p>
              <p
                className="float-start ms-2"
                style={{
                  textDecorationLine: props.foundUser.IsDeleted
                    ? "line-through"
                    : "none",
                }}
              >
                {props.foundUser.Name}
              </p>
            </div>

            <div className="align-items-baseline d-flex">
              <p className="lead float-start ms-3">
                <FormattedMessage id="Type" />:
              </p>
              <p className="float-start ms-2">{props.foundUser.Type}</p>
            </div>

            {props.foundUser.Type === "Teacher" && (
              <div className="align-items-baseline d-flex">
                <p className="lead float-start ms-3">
                  <FormattedMessage id="FullTeacherAccess" />:{" "}
                </p>
                <p className="float-start ms-2">
                  {props.foundUser.HasFullTeacherAccess ? (
                    <FormattedMessage id="true" />
                  ) : (
                    <FormattedMessage id="false" />
                  )}
                </p>
              </div>
            )}

            {props.foundUser.Type === "Teacher" && (
              <div className="align-items-baseline d-flex">
                <p className="lead float-start ms-3">
                  <FormattedMessage id="IsPurchaser" />:{" "}
                </p>
                <p className="float-start ms-2">
                  {props.foundUser.IsPurchaser ? (
                    <FormattedMessage id="true" />
                  ) : (
                    <FormattedMessage id="false" />
                  )}
                </p>
              </div>
            )}

            {props.foundUser.Type !== "Superuser" &&
              props.foundUser.Type !== "Admin" && (
                <div className="align-items-baseline d-flex">
                  <p className="lead float-start ms-3">
                    {props.foundUser.Schools.length > 1 ? (
                      <FormattedMessage id="Schools" />
                    ) : (
                      <FormattedMessage id="School" />
                    )}
                  </p>
                  {props.foundUser.Schools.map((school, index) => (
                    <span
                      className={index === 0 ? "ms-2" : ""}
                      key={`school_${index}`}
                    >
                      {(index ? ", " : "") + school.name + " ("}
                      <FormattedMessage id="FortnoxNumber" />{" "}
                      {": " + school.fortNoxNumber + ")"}
                    </span>
                  ))}
                </div>
              )}

            {props.foundUser.ClassIsDeleted && (
              <div className="align-items-baseline d-flex">
                <p className="lead float-start ms-3">
                  <FormattedMessage id="ClassDeleted" />
                </p>
                <p className="float-start ms-2">
                  <FormattedMessage id="true" />
                </p>
              </div>
            )}

            {props.foundUser.Type !== "Superuser" &&
              props.foundUser.Type !== "Admin" && (
                <div className="d-flex align-items-baseline">
                  <p className="lead float-start ms-3">
                    {props.foundUser.Classes.length > 1 ? (
                      <FormattedMessage id="Classes" />
                    ) : (
                      <>
                        <FormattedMessage id="Class" />:
                      </>
                    )}
                  </p>
                  <div className="d-flex flex-wrap gap-2">
                    {props.foundUser.Classes.map((cl, index) => (
                      <span
                        key={`class_${index}`}
                        color="light"
                        className="float-start ms-2"
                        style={{
                          textDecorationLine: props.foundUser.ClassIsDeleted
                            ? "line-through"
                            : "none",
                        }}
                      >
                        {cl}
                      </span>
                    ))}
                  </div>
                </div>
              )}

            {props.foundUser.Type === "Student" && (
              <div className="align-items-baseline d-flex">
                <p className="lead float-start ms-3">
                  <FormattedMessage id="LicenseOnSchool" />:
                </p>
                <p className="float-start ms-2">
                  {props.foundUser.LicenceOnSchool}
                </p>
              </div>
            )}

            {props.foundUser.Type === "Student" && (
              <div className="d-flex align-items-baseline">
                <p className="lead float-start ms-3">
                  <FormattedMessage id="AplLicenseValidTo" />:
                </p>
                <div
                  className="float-start ms-2"
                  style={{
                    textDecorationLine:
                      props.foundUser.IsDeleted ||
                      (props.foundUser.AplLicenseValidTo &&
                        props.foundUser.AplLicenseValidTo <
                          new Date().toISOString().split("T")[0])
                        ? "line-through"
                        : "none",
                  }}
                >
                  {props.foundUser.AplLicenseValidTo}
                </div>
              </div>
            )}

            {props.foundUser.Type === "Student" && (
              <div className="d-flex align-items-baseline">
                <p className="lead float-start ms-3">
                  <FormattedMessage id="Licenses" />:
                </p>
                <div className="d-flex flex-wrap gap-2 mt-1 ms-2">
                  {props.foundUser.ProgramLicenses.map(
                    (programLicense, index) => (
                      <Badge color="light" key={`program_license_${index}`}>
                        {programLicense}
                      </Badge>
                    )
                  )}
                </div>
              </div>
            )}

            {props.foundUser.Type === "Student" && (
              <div className="d-flex align-items-baseline">
                <p className="lead float-start ms-3">
                  <FormattedMessage id="Courses" />:
                </p>
                <div className="d-flex flex-wrap gap-2 mt-1 ms-2">
                  {props.foundUser.Licenses.map((courselicense, index) => (
                    <Badge color="light" key={`course_license_${index}`}>
                      {courselicense}
                    </Badge>
                  ))}
                </div>
              </div>
            )}
          </div>
        </Col>
      </Row>
    );
  } else {
    return (
      <Row>
        <Col xs="12">
          <div className="card card-body mt-3" style={{ width: "50%" }}>
            <p className="lead">{props.foundUser.failMessage}</p>
          </div>
        </Col>
      </Row>
    );
  }
}
